import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useStore, useToast, usePopup, usePage, useAuth } from "@/comn/hooks"; // hook
import { URLS, APIS, SG_BLL_RCPN_LIST, SF_BLL_RCPN_SRCH } from "./services/OsciBllRgService"; // 서비스
import dayjs from "dayjs";

/*
 * Bill Receive Data List
 * !== 고지 수신 목록 ==!
 */
export const OSCI0406002Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const auth = useAuth();

    useResource({
        defaultSchema: [
            { area: "cstmCd" },
            { area: "coCd" },
            { area: "bnkCd" },
            { area: "comnCd", comnCd: "OSC0073" },
            { area: "comnCd", comnCd: "OSC0075" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Bill Receive Data List Search Form !== 고지 수신 목록 검색 폼 ==!
        bllRcpnSrch: useForm({
            defaultSchema: SF_BLL_RCPN_SRCH,
            defaultValues: {
                cstmOfceCd: auth.get("cstmCd"),
                strtDt: comnUtils.getDate({ d: -7 }),
                endDt: comnUtils.getDate(),
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Receive Data List Grid !== 고지 수신 목록 그리드 ==!
        bllRcpnList: useGrid({
            defaultSchema: SG_BLL_RCPN_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Bill Reception List !== 고지 수신 목록 조회 ==!
        getBllRcpnList: useFetch({
            api: (page = grid.bllRcpnList.page) => {
                return APIS.getBllRcpnList(form.bllRcpnSrch.getValues(), page, grid.bllRcpnList.size);
            },
            enabled: comnUtils.isEmpty(form.bllRcpnSrch.errors) && form.bllRcpnSrch.isSubmitted,
            key: [grid.bllRcpnList.page, grid.bllRcpnList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.bllRcpnSrch.getValues(),
                    page: grid.bllRcpnList.page,
                    size: grid.bllRcpnList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Bill Reception List !== 고지 수신 목록 조회 ==!
        getBllRcpnList: () => {
            form.bllRcpnSrch.handleSubmit(
                (data) => {
                    grid.bllRcpnList.setPage(0);
                    fetch.getBllRcpnList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_bllRcpnList: {
            cell: {
                bllNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <span style={{ color: "blue" }}>
                            <Link
                                to=""
                                onClick={() => {
                                    let nBllMgmtId = `${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`;
                                    popupFunc.openBllPopup(nBllMgmtId); // 고지정보 조회 팝업
                                }}
                            >{`${rowValues.bllNo}`}</Link>
                        </span>
                    );
                },
                tansadNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        rowValues.reffKeyTpCd == "T" && (
                            <span style={{ color: "blue" }}>
                                <Link
                                    to=""
                                    onClick={() => {
                                        popupFunc.openTansadPopup(`${rowValues.tansadNo}`); // TANSAD정보 조회 팝업
                                    }}
                                >{`${rowValues.tansadNo}`}</Link>
                            </span>
                        )
                    );
                },
                txprTin: (props: any) => {
                    const { rowValues } = props;
                    return `[${rowValues.txprTin}] ${rowValues.txprNm}`;
                },
            },
        },
    };

    // 팝업 호출
    const popupFunc = {
        // 고지 팝업
        openBllPopup: (bllNo: any) => {
            popup.openPopup({
                url: `${URLS.osci0401002q}/${bllNo}`,
                size: "md",
                layout: "popup",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
        // TANSAD 팝업
        openTansadPopup: (tansadNo: any) => {
            popup.openPopup({
                url: `${URLS.osci0202002q}/${tansadNo}`,
                size: "md",
                layout: "popup",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getBllRcpnList();
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>{<Group.Control {...form.bllRcpnSrch.schema.rcpnDt}></Group.Control>}</Group.Row>
                            <Group.Row>
                                <Group.Label label={"L_BLL_NO"} />
                                <Group.Col>
                                    {/* 고지번호 */}
                                    <Group.Control
                                        {...form.bllRcpnSrch.schema.bllTpCd}
                                        onPaste={(e: any) => {
                                            e.preventDefault();
                                            const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                            form.bllRcpnSrch.setValue("bllTpCd", data.substring(0, 1));
                                            form.bllRcpnSrch.setValue("bllSysmCd", data.substring(1, 5));
                                            form.bllRcpnSrch.setValue("bllYy", data.substring(5, 7));
                                            form.bllRcpnSrch.setValue("bllSrno", data.substring(7, 14));
                                            form.bllRcpnSrch.setValue("bllDgr", data.substring(14, 15));
                                        }}
                                    />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllRcpnSrch.schema.bllSysmCd} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllRcpnSrch.schema.bllYy} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllRcpnSrch.schema.bllSrno} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllRcpnSrch.schema.bllDgr} />
                                </Group.Col>

                                <Group.Label label={"L_TANSAD_NO"} />
                                <Group.Col>
                                    {/* TANSAD번호 */}
                                    <Group.Control
                                        {...form.bllRcpnSrch.schema.tansadCstmOfceCd}
                                        onPaste={(e: any) => {
                                            e.preventDefault();
                                            const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                            form.bllRcpnSrch.setValue("tansadCstmOfceCd", data.substring(0, 4));
                                            form.bllRcpnSrch.setValue("tansadYy", data.substring(4, 6));
                                            form.bllRcpnSrch.setValue("tansadSrno", data.substring(6, 13));
                                        }}
                                    ></Group.Control>
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllRcpnSrch.schema.tansadYy}></Group.Control>
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllRcpnSrch.schema.tansadSrno}></Group.Control>
                                </Group.Col>
                            </Group.Row>
                            <Group.Row>
                                {<Group.Control {...form.bllRcpnSrch.schema.rcpnStts}></Group.Control>}
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.bllRcpnSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getBllRcpnList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Button
                        role="excelDown"
                        onClick={() => {
                            grid.bllRcpnList.exportExcel({
                                /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,

                                /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                sheetName: "Sheet Name",
                            });
                        }}
                    ></Button>
                    <Group.Section>
                        <Grid
                            {...grid.bllRcpnList.grid}
                            data={fetch.getBllRcpnList.data?.bllRcpnList}
                            render={render.grid_bllRcpnList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
